import * as React from "react";

export interface Response {
  status: "idle" | "loading" | "complete" | "failed";
}

export default function useImage(src: string): Response {
  const [response, setResponse] = React.useState<Response>({ status: "idle" });

  React.useEffect(() => {
    let img = new Image();
    const onLoad = (e: any) => {
      setResponse({ status: "complete" });
    };
    img.onload = onLoad;

    const loadImage = (src: string) => {
      img.src = src;
    };

    if (src && response.status === "idle") {
      loadImage(src);
    }

    return () => {
      img.onload = null;
    };
  }, [src]);

  return response;
}
